import { RelatedProductsAccordion } from 'components/Product';
import { PRODUCT_DETAILS_ACCESSORIES_ID } from 'constants/ids';
import type { VariantId } from 'models/product';

import { useAccessoriesContext } from '../ProductDetailsContext';

interface Props {
	contentClassName: string;
	expiredProductsTitle: string;
	loadMoreButtonText: string;
	noProductsText: string;
	title: string;
	variantId: VariantId;
}

export default function AccessoriesAccordion({
	contentClassName,
	expiredProductsTitle,
	loadMoreButtonText,
	noProductsText,
	title,
	variantId,
}: Props) {
	const {
		hasNextPage,
		isLoading,
		isLoadingMore,
		isOpen,
		items,
		loadMore,
		toggleOpen,
	} = useAccessoriesContext();

	return (
		<RelatedProductsAccordion
			accordionId={PRODUCT_DETAILS_ACCESSORIES_ID}
			expiredProductsTitle={expiredProductsTitle}
			loadMoreButtonText={loadMoreButtonText}
			title={title}
			gtmItemListId="pdp_accessories"
			gtmItemListName={`List: Accessories ${variantId}`}
			engagementType="addAccessoryToCart"
			noProductsText={noProductsText}
			products={items}
			isLoadingInitial={isLoading}
			isLoadingMore={isLoadingMore}
			hasNextPage={hasNextPage}
			onLoadMoreClick={loadMore}
			contentClassName={contentClassName}
			isOpen={isOpen}
			onClick={toggleOpen}
		/>
	);
}

AccessoriesAccordion.displayName = 'AccessoriesAccordion';
